/**
 * Tiny Tags Journal — accessible "Load More" pagination.
 * Fetches the next blog page and appends its articles into the current
 * page instead of navigating away, keeping focus/announcements ADA-friendly.
 */
(function () {
  'use strict';

  function initLoadMoreButton(button) {
    if (button.hasAttribute('data-tt-loadmore-bound')) return;
    button.setAttribute('data-tt-loadmore-bound', 'true');

    var label = button.querySelector('[data-tt-loadmore-label]');
    var defaultLabel = label ? label.textContent : button.textContent;
    var wrap = button.closest('[data-tt-loadmore-wrap]');
    var status = wrap ? wrap.querySelector('[data-tt-loadmore-status]') : null;

    button.addEventListener('click', function () {
      var nextUrl = button.getAttribute('data-next-url');
      var containerId = button.getAttribute('aria-controls');
      var container = containerId ? document.getElementById(containerId) : null;

      if (!nextUrl || !container) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Loading more stories…';
      if (status) status.textContent = 'Loading more stories.';

      fetch(nextUrl)
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed with status ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextContainer = doc.getElementById(containerId);
          var nextButton = nextContainer
            ? doc.querySelector('[aria-controls="' + containerId + '"][data-tt-loadmore-btn]')
            : null;

          var addedCount = 0;
          if (nextContainer) {
            var fragment = document.createDocumentFragment();
            Array.prototype.forEach.call(nextContainer.children, function (child) {
              addedCount += child.classList.contains('tt-card') || child.classList.contains('tt-featured') ? 1 : 0;
              fragment.appendChild(document.importNode(child, true));
            });
            container.appendChild(fragment);
          }

          if (nextButton) {
            button.setAttribute('data-next-url', nextButton.getAttribute('data-next-url'));
            button.disabled = false;
            button.removeAttribute('aria-busy');
            if (label) label.textContent = defaultLabel;
          } else {
            button.remove();
          }

          if (status) {
            status.textContent = addedCount > 0
              ? addedCount + ' more ' + (addedCount === 1 ? 'story' : 'stories') + ' loaded.'
              : 'No more stories to load.';
          }
        })
        .catch(function () {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (label) label.textContent = defaultLabel;
          if (status) status.textContent = 'Sorry, we couldn’t load more stories. Please try again.';
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-tt-loadmore-btn]').forEach(initLoadMoreButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
